import React from 'react';
import { Empty, Table, Select, DatePicker } from "antd";
import utils from "../common/utils";
import { Translation } from "react-i18next";
import LoadingComponent from "./common/LoadingComponent";
import consts from "../consts";
import moment from 'moment'
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
const { Option } = Select
const { RangePicker } = DatePicker

class OrderTransactionHistoryComponent extends LoadingComponent {
	columns = (t) => [
		{
			align: "center",
			title:  t('user.order_trans.id'),
			width: 60,
			dataIndex: 'id',
		},
		{
			align: "center",
			title: t('user.open_order.transfer'),
			width: 100,
			dataIndex: 'transaction_type',
			key: 'transaction_type',
			render: (type) => <div
				style={{ color: (type === consts.ORDER_TRADE_TYPE_BUY) ? 'green' : 'red' }}>{type === consts.ORDER_TRADE_TYPE_BUY ? t('Buy') : t('Sell')}</div>
		},
		{
			align: "center",
			title: t('user.open_order.id'),
			width: 60,
			dataIndex: 'order_id',
			key: 'order_id',
		},
		{
			align: "center",
			title: t('user.open_order.pair'),
			width: 120,
			dataIndex: 'pair',
			key: 'pair',
		},
		{
			align: "center",
			title: t('user.open_order.withdrawal'),
			width: 100,
			dataIndex: 'price',
			key: 'price',
			render: (price, {currency}) => `${utils.formatCurrency(price)} ${currency}`
		},
		{
			align: "center",
			title: t('user.open_order.coin'),
			width: 100,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity, {coin}) => <div title={quantity}>{utils.formatCurrency(quantity)} {coin}</div>,
		},
		{
			align: "center",
			title: t('user.open_order.created_at'),
			width: 150,
			dataIndex: 'created_at',
			key: 'created_at',
		},
	];

	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			currentPage: 1,
			totalCount: 0,
		};
		this.filter = {
			pos: 0,
			count: consts.DEFAULT_PAGE_SIZE,
			coin: '',
			currency: '',
			order_type: '',
			trade_type: '',
			start_time: '',
			end_time: '',
		}
	}

	componentDidMount() {
		this.fetchData()
	}

	fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
		this.enLoading();
		this.filter = {
			...this.filter,
			pos,
			count,
		}
		this.props.onFetchUserOrderTransactionsAction(this.filter, this.updateTotalCount);
	}

	updateTotalCount = (totalCount) => {
		this.setState({
			totalCount,
		})
		this.unLoading()
	}

	changeTradeType = (trade) => {
		this.filter = {
			...this.filter,
			trade_type: trade,
		}
		this.fetchData()
	}

	changeOrderType = (order) => {
		this.filter = {
			...this.filter,
			order_type: order,
		}
		this.fetchData()
	}

	changeMarket = (pair) => {
		let str = pair.split("/")
		let coin = str[0];
		let currency = str[1];
		this.filter = {
			...this.filter,
			coin,
			currency,
		}
		this.fetchData()
	}

	onChangeDate = (data) => {
		if(!!data){
			this.filter = {
				...this.filter,
				start_time: data[0].startOf('day').unix(),
				end_time: data[1].endOf('day').unix(),
			}
		}
		else{
			this.filter = {
				...this.filter,
				start_time: '',
				end_time: '',
			}
		}
		this.fetchData()
	}

	render() {
		return (
			<Translation>
				{(t) => <div className="depositandwithdrawal user-wallet">
					{/*<h1 className="text-white text-left">{t('user.order_tran.title')}</h1>*/}
					<div className="depositandwithdrawal-top" >
						<div className="coin-container">
							<div className='control'>
								<span className='label'> {t('user.open_order.transfer')} </span>
								<Select defaultValue="-1" style={{ width: 120 }} className='coinSelect' onChange={this.changeTradeType}>
									<Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
									<Option value="0">{t('user.open_order.buy')} </Option>
									<Option value="1"> {t("user.open_order.sell")} </Option>
								</Select>
							</div>
							{/* <div className='control'>
								<span className='label'> {t('user.open_order.order_type')} </span>
								<Select defaultValue="-1" style={{ width: 120 }} className='coinSelect' onChange={this.changeOrderType}>
									<Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
									<Option value="0"> {t('user.open_order.limit')} </Option>
									<Option value="1"> {t('user.open_order.market')} </Option>
									<Option value="2"> {t('user.open_order.stop_limit')}</Option>
								</Select>
							</div> */}
							<div className='control'>
								<span className='label'> {t('user.open_order.pair')} </span>
								<Select defaultValue="" style={{ width: 120 }} className='coinSelect' onChange={this.changeMarket}>
									<Option value=""> {t('user.deposit_and_withdrawal.all')} </Option>
									{window._.map((this.props.setting?.coinSettings || []), (item) => {
										return <Option key={item.pair}>
											<div className="ln-big">
												{item.pair}
											</div>
										</Option>
									})}
								</Select>
							</div>
							<div className='control'>
								<span className='label'> {t('user.deposit_and_withdrawal.deposit_and_withdrawal_date')} </span>
								<RangePicker className="date-picker1" format={'DD/MM/YYYY'}
								separator={<HiOutlineArrowNarrowRight style={{fontSize: 11, marginRight: 10, color: 'rgba(0, 0, 0, 0.25)'}}/>}
									disabledDate={(current) => current && current > moment().endOf('day')}
									placeholder={[
										t('user.deposit_and_withdrawal.deposit_and_withdrawal_start_date'),
										t('user.deposit_and_withdrawal.deposit_and_withdrawal_end_date')
									]}
									onChange={this.onChangeDate}
								/>
							</div>
						</div>
					</div>
					<Table columns={this.columns(t)}
						//    scroll={{y: '65vh'}}
						rowClassName="pointer"
						locale={{ emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>} />) }}
						pagination={{
							showQuickJumper: true,
							current: this.state.currentPage,
							onChange: (page, pageSize) => {
								this.fetchData((page - 1) * pageSize, pageSize)
								this.setState({ currentPage: page })
							},
							defaultPageSize: 10,
							total: this.state.totalCount,
							hideOnSinglePage: true,
						}}
						dataSource={[...this.props.orderTrans.userOrderTransactions || []]}
						loading={this.state.isLoading}
						className="depositandwithdrawal-top"
					/>
				</div>}
			</Translation>
		);
	}
}

export default OrderTransactionHistoryComponent;
